import { GET_WAREHOUSES } from '../actions/types';
export default function (state = false, action) {
    switch (action.type) {
        case GET_WAREHOUSES:
            return action.payload;
        default:
            return state;
    }
}